import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { components } from './GlobalPayrollSlice';

export const Wrapper = styled.section`
  background-image: var(--colors-zircon);
  ${fluidProp('padding-top', '100px', '150px')};
  ${fluidProp('padding-bottom', '50px', '75px')};
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.scale3};
  ${fluidProp('font-size', '30px', '42px')};
  margin-bottom: 12px;
  color: var(--colors-darkBlue);

  & > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.bodyLead};
  color: var(--colors-lynch);

  & > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
`;

export function ManagePayrollSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { manageTitle, manageDescription } = primary;

  return (
    <Wrapper>
      <ContentContainer>
        {fieldHasContent(manageTitle) && (
          <Title>
            <PrismicRichText field={manageTitle} />
          </Title>
        )}
        {fieldHasContent(manageDescription) && (
          <Description>
            <PrismicRichText field={manageDescription} components={components} />
          </Description>
        )}
      </ContentContainer>
    </Wrapper>
  );
}
